<template lang="pug">
#register.container
  .row
    h2.col-12.text-center Register
    .col-12.col-md-6.offset-md-3
      .card-item
        form(@submit.prevent='registerClick()')
          .form-group
            label Email
            input.form-control(type='email', v-model='email', required)
          .form-group
            label Password
            input.form-control(type='password', v-model='password', required)
          .form-group
            label Confirm Password
            input.form-control(type='password', v-model='confirmPassword', required)
          button.btn.btn-primary(v-if='!loading') Register
          button.btn.btn-primary(v-else, disabled) Loading...
</template>

<style lang="scss" scoped>
  #register {
    padding-top: 1rem;
  }
</style>

<script>
import {
  register,
  getUser
} from '../lib/api'

export default {
  name: 'Register',
  data () {
    return {
      loading: false,
      email: '',
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    async registerClick () {
      if (this.password !== this.confirmPassword) {
        alert('Passwords do not match')
        return
      }

      this.loading = true

      const res = await register(this.email, this.password)
      this.loading = false
      if (!res) return

      this.user = await getUser();
      this.$router.push({ name: 'Account' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue